export const MTipoDeAvisos: ITipoDeAvisos[] = [
    // Aviso referente a: 1=Genérico, 2=Pedidos, 3=Entradas
    { valor: 1, titulo: "Genérico", icono: "fa-solid fa-message" },
    { valor: 2, titulo: "Pedidos", icono: "fa-solid fa-box-open" },
    { valor: 3, titulo: "Entradas", icono: "fa-solid fa-truck-arrow-right" },
];

export interface ITipoDeAvisos {
    valor: number | null;
    titulo: string;
    icono: string;
}